import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export interface CircularLoaderProps {
  size?: number; // overall diameter
  thickness?: number; // stroke width
  trackColor?: string; // background circle color
  progressColor?: string; // rotating arc color
  arcLength?: number; // controls visible arc size
}

const CircularLoader: React.FC<CircularLoaderProps> = ({
  size = 80,
  thickness = 4,
  trackColor = '#d9d9d9',
  progressColor = '#3b1fd1',
  arcLength = 25,
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        width: size,
        height: size,
      }}
    >
      {/* Background Track */}
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        thickness={thickness}
        sx={{
          color: trackColor,
          position: 'absolute',
          left: 0,
        }}
      />

      {/* Rotating Arc */}
      <CircularProgress
        variant="indeterminate"
        disableShrink
        size={size}
        thickness={thickness}
        sx={{
          color: progressColor,
          position: 'absolute',
          left: 0,
          animationDuration: '1.2s',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
            strokeDasharray: `${arcLength}px, 200px`,
          },
        }}
      />
    </Box>
  );
};

export default CircularLoader;
